/**
 * Référencement : titre, description, URL canonique et aperçu social propres à chaque
 * page. Sans cela, Google voyait le même titre partout (« FodindinCa — Rencontres en
 * Côte d'Ivoire ») et considérait les pages comme dupliquées, ce qui ralentit
 * fortement l'indexation.
 */
import { useEffect } from "react";

const SITE = "https://fodindinca.com";

const majBalise = (selecteur, attribut, valeur) => {
  if (!valeur) return;
  let el = document.head.querySelector(selecteur);
  if (!el) {
    el = document.createElement(selecteur.startsWith("link") ? "link" : "meta");
    const [, nom, contenu] = selecteur.match(/\[(.+?)="(.+?)"\]/) || [];
    if (nom && contenu) el.setAttribute(nom, contenu);
    document.head.appendChild(el);
  }
  el.setAttribute(attribut, valeur);
};

export const useSeo = ({ titre, description, image = null, chemin = null }) => {
  useEffect(() => {
    const titreComplet = titre ? `${titre} | FodindinCa` : "FodindinCa — Rencontres en Côte d'Ivoire";
    document.title = titreComplet;
    majBalise('meta[name="description"]', "content", description);
    majBalise('link[rel="canonical"]', "href", `${SITE}${chemin || window.location.pathname}`);
    majBalise('meta[property="og:title"]', "content", titreComplet);
    majBalise('meta[property="og:description"]', "content", description);
    majBalise('meta[property="og:type"]', "content", "website");
    majBalise('meta[property="og:url"]', "content", `${SITE}${chemin || window.location.pathname}`);
    majBalise('meta[name="twitter:card"]', "content", image ? "summary_large_image" : "summary");
    if (image) {
      const absolue = image.startsWith("http") ? image : `${process.env.REACT_APP_BACKEND_URL}${image}`;
      majBalise('meta[property="og:image"]', "content", absolue);
      majBalise('meta[name="twitter:image"]', "content", absolue);
    }
  }, [titre, description, image, chemin]);
};

/** Données structurées (JSON-LD) injectées puis retirées au démontage. */
export const useDonneesStructurees = (donnees) => {
  useEffect(() => {
    if (!donnees) return undefined;
    const script = document.createElement("script");
    script.type = "application/ld+json";
    script.textContent = JSON.stringify(donnees);
    document.head.appendChild(script);
    return () => script.remove();
  }, [donnees]);
};
